import { ChakraProvider } from '@chakra-ui/react'
import '@fontsource-variable/inter/index.css'

import { theme } from '../theme'

export const ThemeProvider = (props: React.PropsWithChildren) => {
	return (
		<ChakraProvider
			theme={theme}
			resetCSS={false}
		>
			{props.children}
		</ChakraProvider>
	)
}
